{
  "ui": {
    "status.pass": "All checks passed",
    "status.warn": "Passed with warnings",
    "status.fail": "Checks failed",
    "status.error": "Errors encountered",
    "overall.label": "Result",
    "overall.PASS": "Pass",
    "overall.WARN": "Warning",
    "overall.FAIL": "Fail",
    "overall.ERROR": "Error",
    "detect.switchPrompt": "{{suite}} enrollment detected.",
    "detect.switchAction": "Switch",
    "detect.unknown": "We were unable to verify the correct program for this contact from its enrollment plan. Please ensure an enrollment plan exists and that it matches the QC program you have selected.",
    "program.label": "Program",
    "program.selectAria": "Select QC suite",
    "remediation.label": "Remediation",
    "input.placeholder": "Enter a Forth Contact ID or Contact URL",
    "input.submit": "Run QC",
    "input.loading": "Running…",
    "input.clear": "Clear",
    "input.detectedContactId": "Detected Contact ID",
    "loading.checks": "Running checks…",
    "history.title": "Total runs ({{count}})",
    "history.copyLink": "Copy link to this run",
    "history.copied": "Copied!",
    "submit.barLabel": "QC result actions",
    "submit.submit": "Submit",
    "submit.submitForReview": "Submit for Review",
    "submit.submitting": "Submitting…",
    "submit.submitted": "Submitted",
    "submit.submittedStamp": "on {{date}} by {{email}}",
    "submit.submittedShort": "Submitted",
    "submit.retryWorkflow": "Retry",
    "submit.tryAgain": "Try again",
    "submit.confirm": "Confirm",
    "submit.cancel": "Cancel",
    "submit.confirmTitle": "Submit QC result",
    "submit.confirmBody": "Submit these QC results? This posts the report to Forth and advances the customer's workflow.",
    "submit.workflowError": "Result saved to Forth, but the workflow didn't start. Retry won't re-post the note.",
    "submit.noteErrorGeneric": "Failed to post to Forth.",
    "submit.serverError": "Couldn't reach the server. Please try again.",
    "submit.historicalTooltip": "Submit is only available on the latest run.",
    "submit.blockedWrongProgram": "Submission is disabled for this run because the contact's enrollment plan doesn't match the selected program. Confirm you've selected the right program, then run QC again to submit.",
    "submit.blockedNoPlan": "Submission is disabled for this run because we could not detect a valid enrollment plan for this contact.",
    "submit.blockedTooltip": "Submission is disabled because of an enrollment-plan mismatch.",
    "submit.rerun": "Run Again",
    "submit.startOver": "Start Over",
    "submit.historicalBanner": "Viewing a previous run.",
    "actions.meta": "{{requests}} requests · {{seconds}}s",
    "alert.contactUnavailable": "Couldn't load contact {{contactId}} from Forth. Double-check the Contact ID and try again.",
    "alert.runFailed": "Something went wrong running the QC checks. Please try again.",
    "skip.unknownCheck": "Unknown check: {{checkId}}",
    "skip.missingEnrollmentPlan": "No enrollment plan on file — check skipped",
    "skip.missingCreditReport": "No credit report on file — check skipped",
    "skip.missingEnrolledDebts": "No enrolled debts on file — check skipped",
    "auth.magicLink.emailHint": "No Foundation account? Enter your email and we'll send you a sign-in link.",
    "auth.magicLink.emailLabel": "Email address",
    "auth.magicLink.emailPlaceholder": "you@example.com",
    "auth.magicLink.emailSubmit": "Send sign-in link",
    "auth.magicLink.emailLoading": "Sending…",
    "auth.magicLink.divider": "or",
    "auth.magicLink.codeSent": "We emailed a sign-in link and a 6-digit code to {{email}} — enter the code below or click the link in the email.",
    "auth.magicLink.codeLabel": "6-digit code",
    "auth.magicLink.codePlaceholder": "123456",
    "auth.magicLink.codeSubmit": "Verify code",
    "auth.magicLink.codeLoading": "Verifying…",
    "auth.magicLink.resend": "Resend code",
    "auth.magicLink.resendLoading": "Resending…",
    "auth.magicLink.backToEmail": "Use a different email",
    "auth.magicLink.resendCooldown": "Please wait before requesting another code",
    "auth.magicLink.resendSuccess": "Code resent — check your email",
    "admin.title": "Company Allowlist",
    "admin.notAuthorized": "Not authorized. This page is for RP staff only.",
    "admin.loadError": "Failed to load companies.",
    "admin.loading": "Loading…",
    "admin.noCompanies": "No companies yet. Add one above.",
    "admin.newCompanyLabel": "New company name",
    "admin.newCompanyPlaceholder": "Company Name",
    "admin.addCompany": "Add company",
    "admin.addCompanyLoading": "Adding…",
    "admin.deleteCompany": "Delete company",
    "admin.confirmDelete": "Delete \"{{name}}\"? This cannot be undone.",
    "admin.domains": "Allowed domains",
    "admin.noDomains": "No domains",
    "admin.addDomainLabel": "Add domain",
    "admin.addDomainPlaceholder": "example.com",
    "admin.addDomain": "Add",
    "admin.emails": "Allowed emails",
    "admin.noEmails": "No specific emails",
    "admin.addEmailLabel": "Add email",
    "admin.addEmailPlaceholder": "user@example.com",
    "admin.addEmail": "Add",
    "admin.remove": "Remove",
    "admin.actionError": "Error: {{error}}"
  },
  "checks": {
    "ageLimit": {
      "description": "Verifies the client's age is within the maximum limit for program eligibility.",
      "displayName": "Age Limit",
      "pass": "Client age ({{age}}) is within limit ({{maxAge}})",
      "fail": "Client age ({{age}}) exceeds maximum ({{maxAge}})",
      "fail.noDob": "No date of birth on file",
      "remediation.exceedsMax": "Client is not eligible for enrollment — age exceeds the {{maxAge}}-year limit.",
      "remediation.noDob": "Verify and enter the client's date of birth before proceeding.",
      "label.age": "Client Age"
    },
    "clientInfoAccuracy": {
      "description": "Compares the client's name, full Social Security number, and date of birth against the credit report. Also checks the address against all current and prior addresses on file in the credit report — a mismatch here is a warning only, since clients may have moved since the debt was originally reported.",
      "displayName": "Credit Report Match",
      "pass": "All client info matches credit report",
      "fail": "{{count}} field(s) do not match the credit report",
      "warn": "{{count}} field(s) have low similarity with the credit report",
      "error.noCreditReport": "Credit report could not be loaded",
      "fail.noReport": "No credit report on file for this customer",
      "remediation.fieldMismatch": "Verify the customer's {{fieldName}} against the credit report and correct any discrepancies.",
      "remediation.noCreditReport": "Re-run the check. If the issue continues, reach out to your administrator.",
      "remediation.noReport": "Pull a credit report and upload it before proceeding with enrollment.",
      "label.name": "Name",
      "label.address": "Address",
      "label.ssn": "SSN",
      "label.dob": "Date of Birth"
    },
    "companyDuplicate": {
      "description": "Searches for any existing file with the same SSN associated with a set of historical parent companies, regardless of enrollment status.\n\nMonitored companies:\n• Morning Law Group\n• Morning Law Group - BK\n• MLG - Migration\n• BK - Rejected Clients DNC\n• Resolution Processing",
      "displayName": "Unenrolled Duplicate",
      "pass": "No unenrolled duplicates found",
      "fail": "Found {{count}} file(s) with the same SSN at a historical parent company",
      "skip.noSsn": "No SSN on file — duplicate check skipped (see Social Security Number check)",
      "skip.invalidSsn": "SSN is invalid — duplicate check skipped (see Social Security Number check)",
      "remediation.existing": "Review the existing file(s) and confirm this is not a duplicate before proceeding.",
      "label.duplicates": "Duplicates"
    },
    "creditReportPresent": {
      "description": "Confirms a credit report has been pulled and is on file for this client.",
      "displayName": "Credit Report",
      "pass": "Credit report has been uploaded",
      "fail": "No credit report found on file",
      "error.apiUnavailable": "Credit report could not be retrieved — check cannot be completed",
      "remediation.missing": "Pull a credit report and upload it before proceeding with enrollment.",
      "remediation.apiUnavailable": "Re-run the check. If the issue continues, reach out to your administrator.",
      "label.creditReport": "Credit Report"
    },
    "debtCompleteness": {
      "description": "Checks that all enrolled debts have the required fields filled in (creditor name, account number, debt type).",
      "displayName": "Debt Completeness",
      "pass": "All {{debtCount}} enrolled debts have required fields",
      "fail": "{{issueCount}} of {{debtCount}} enrolled debts are missing: {{missingFields}}",
      "fail.noDebts": "No enrolled debts found for this customer",
      "error.apiUnavailable": "Enrolled debt information could not be loaded",
      "remediation.apiUnavailable": "Re-run the check. If the issue continues, reach out to your administrator.",
      "remediation.missingFields": "Complete the missing fields (creditor name, account number, or debt type) on all enrolled debts before proceeding.",
      "remediation.noDebts": "Add debts to the enrollment before proceeding.",
      "label.incompleteDebts": "Debts Missing Fields"
    },
    "debtVsPlanMatch": {
      "description": "Compares the total of individually enrolled debts against the agreed total on the Client Services Agreement (CSA) document.",
      "displayName": "Total Debt vs Base Plan",
      "pass": "Enrolled debt total (${{enrolledTotal}}) matches CSA total (${{planTotal}})",
      "error.apiUnavailable": "Enrolled debt information could not be loaded",
      "fail.noDebts": "No enrolled debts found for this customer",
      "fail.noCsa": "No signed Client Services Agreement found on the file",
      "fail.csaUnparseable": "Client Services Agreement was found but its total could not be read",
      "error.csaUnavailable": "Client Services Agreement could not be retrieved — check cannot be completed",
      "remediation.apiUnavailable": "Re-run the check. If the issue continues, reach out to your administrator.",
      "remediation.noDebts": "Add debts to the enrollment before proceeding.",
      "remediation.noCsa": "Generate or verify the signed Client Services Agreement in Forth before this file can pass QC.",
      "remediation.csaUnparseable": "Verify the CSA document in Forth is complete and the total is present, then re-run QC.",
      "remediation.csaUnavailable": "Verify the CSA document exists in Forth and is accessible. Re-run QC once the document is available.",
      "warn.amountMismatch": "Enrolled debt total (${{enrolledTotal}}) differs from CSA total (${{planTotal}}) by ${{difference}}",
      "remediation.amountMismatch": "Reconcile the enrolled debts with the amount agreed in the Client Services Agreement.",
      "label.enrolledTotal": "Enrolled Total"
    },
    "emailValidation": {
      "description": "Verifies the customer has a valid email address on file.",
      "displayName": "Email Address",
      "pass": "Email address is valid ({{email}})",
      "fail.missing": "No email address on file for this customer",
      "fail.invalidFormat": "Email address is not valid: {{email}}",
      "remediation.email.missing": "Add a valid email address to the customer's contact record before proceeding.",
      "remediation.email.invalid_format": "Correct the email address on the customer's contact record.",
      "label.email": "Email Address"
    },
    "enrolledDuplicate": {
      "description": "Searches for other contacts with the same SSN across all companies in Forth. Actively enrolled duplicates are flagged as failures; previously canceled or dropped files are flagged as warnings. Files where this SSN appears as a co-applicant are also flagged as warnings. For files associated with historical parent companies, see the Unenrolled Duplicate check.",
      "displayName": "Enrolled Duplicate",
      "pass": "No enrolled duplicates found",
      "fail": "Found {{count}} actively enrolled file(s) with the same SSN",
      "warn": "Found {{count}} canceled or re-enrollment-eligible file(s) with the same SSN",
      "warn.coapp": "Found {{count}} file(s) where this SSN appears as a co-applicant — verify these are not actively enrolled before proceeding",
      "skip.noSsn": "No SSN on file — duplicate check skipped (see Social Security Number check)",
      "skip.invalidSsn": "SSN is invalid — duplicate check skipped (see Social Security Number check)",
      "remediation.existing": "Review the existing enrolled file(s) and confirm this is not a duplicate before proceeding.",
      "remediation.canceled": "Review the canceled file(s) and verify the prior enrollment before proceeding.",
      "remediation.coapp_existing": "Verify whether the co-applicant file(s) listed are still actively enrolled before proceeding.",
      "label.duplicates": "Duplicates"
    },
    "enrollmentPlanPresent": {
      "description": "Confirms the contact has an enrollment plan on file and that the plan belongs to the program this QC suite validates.",
      "displayName": "Enrollment Plan",
      "pass": "Enrollment plan on file (plan {{planId}})",
      "error.apiUnavailable": "Enrollment plan could not be retrieved — check cannot be completed",
      "fail.noPlan": "No enrollment plan saved to this contact",
      "fail.wrongProgram": "Enrollment plan {{planId}} belongs to a different program than this QC suite validates",
      "remediation.apiUnavailable": "Re-run the check. If the issue continues, reach out to your administrator.",
      "remediation.noPlan": "Save an enrollment plan to the contact in Forth before running QC.",
      "remediation.wrongProgram": "Confirm the contact is enrolled in the correct program, or run the QC suite that matches the enrollment plan.",
      "label.planId": "Plan ID"
    },
    "fileType": {
      "description": "Verifies the contact's file type is set to Debt Validation for program eligibility.",
      "displayName": "File Type",
      "pass": "File type is Debt Validation",
      "fail": "File type is \"{{file_type}}\", expected Debt Validation ({{expected}})",
      "remediation.wrongType": "Change the file type to Debt Validation before proceeding.",
      "label.fileType": "File Type"
    },
    "firstPaymentDate": {
      "description": "Checks that the first scheduled payment is within an acceptable timeframe from enrollment.",
      "displayName": "First Payment Date",
      "pass": "First payment date is {{firstPaymentDate}} ({{diffDays}} days from today)",
      "fail.tooSoon": "First payment is only {{businessDays}} business days away (minimum: {{minBusinessDays}})",
      "warn": "First payment date is {{diffDays}} days from today (limit: {{maxDays}})",
      "error.noPlan": "No enrollment plan found for this customer",
      "fail.noPayments": "Enrollment plan has no payments scheduled",
      "remediation.tooSoon": "Reschedule the first payment to at least {{minBusinessDays}} business days out. Exceptions require approval.",
      "remediation.exceedsLimit": "Confirm the payment schedule with the customer — first payment should be within {{maxDays}} days.",
      "remediation.noPlan": "Create an enrollment plan for this customer before proceeding.",
      "remediation.noPayments": "Add a payment schedule to the enrollment plan.",
      "label.firstPaymentDate": "First Payment Date",
      "label.businessDays": "Business Days Out",
      "label.daysFromToday": "Calendar Days Out"
    },
    "isCoApplicant": {
      "description": "Checks whether this contact is registered as a co-applicant file in Forth. Co-applicant files are not eligible for enrollment.",
      "displayName": "Co-Applicant File",
      "pass": "Contact is not a co-applicant",
      "fail": "Contact is registered as a co-applicant — not eligible for independent enrollment",
      "remediation.is_co_applicant": "This file is a co-applicant. Enrollment must be handled through the primary contact's file.",
      "label.coApplicant": "Co-Applicant"
    },
    "minDebtThreshold": {
      "description": "Verifies the client's total enrolled debt meets the minimum dollar threshold for program eligibility.",
      "displayName": "Minimum Enrolled Debt",
      "pass": "Total debt (${{totalDebt}}) meets minimum threshold (${{minDebtAmount}})",
      "fail": "Total debt (${{totalDebt}}) is below minimum threshold (${{minDebtAmount}})",
      "fail.noDebts": "No enrolled debts found — minimum debt threshold cannot be met",
      "error.apiUnavailable": "Enrolled debt information could not be loaded",
      "error.invalidAmount": "Contact total_debt is not a valid number",
      "remediation.belowMinimum": "Client does not qualify — total debt must be at least ${{minDebtAmount}}.",
      "remediation.noDebts": "Add debts to the enrollment before proceeding.",
      "remediation.apiUnavailable": "Re-run the check. If the issue continues, reach out to your administrator.",
      "remediation.invalidAmount": "Correct the total debt field on the contact record — it must be a valid dollar amount.",
      "label.totalDebt": "Total Enrolled Debt"
    },
    "minMonthlyPayment": {
      "description": "Confirms the client's monthly payment amount meets the minimum required for the program.",
      "displayName": "Minimum Monthly Payment",
      "pass": "Monthly payment (${{paymentAmount}}) meets minimum (${{minMonthlyPayment}})",
      "fail": "Monthly payment (${{paymentAmount}}) is below minimum (${{minMonthlyPayment}})",
      "error.noPlan": "No enrollment plan found for this customer",
      "remediation.belowMinimum": "Client does not qualify — monthly payment must be at least ${{minMonthlyPayment}}.",
      "remediation.noPlan": "Create an enrollment plan for this customer before proceeding.",
      "label.monthlyPayment": "Monthly Payment"
    },
    "paymentMethodPresent": {
      "description": "Verifies that a bank account or debit card is on file as a payment method.",
      "displayName": "Payment Method Present",
      "pass": "Bank account on file: {{bank_name}} ending in {{account_number_last4}}",
      "fail": "No payment method (bank account or debit card) is on file",
      "error.unavailable": "Unable to retrieve banking information from Forth",
      "remediation.noPaymentMethod": "Add a bank account or debit card in Forth before processing enrollment.",
      "remediation.apiError": "Retry QC. If the error persists, check Forth API connectivity."
    },
    "programLength": {
      "description": "Checks that the enrollment program length matches the standard duration (or accepted range) configured for the selected plan.",
      "displayName": "Program Guidelines",
      "pass": "Program length ({{months}} months) meets program guidelines ({{standardMonths}} months)",
      "warn": "Program length ({{months}} months) is outside program guidelines ({{standardMonths}} months)",
      "error.noPlan": "No enrollment plan found for this customer",
      "remediation.nonStandard": "Verify the program length is intentional — exceptions for higher debt must be approved.",
      "remediation.noPlan": "Create an enrollment plan for this customer before proceeding.",
      "label.programLength": "Program Length"
    },
    "prohibitedStates": {
      "description": "Verifies the client's state of residence is not on the prohibited list for program enrollment.",
      "displayName": "Prohibited States",
      "pass": "Client state ({{state}}) is not prohibited",
      "fail": "Client is from prohibited state: {{state}}",
      "fail.noState": "Client state is missing — cannot verify prohibited states",
      "remediation.prohibited": "Client is not eligible — {{state}} is a prohibited state for enrollment.",
      "remediation.no_state": "Update the client's address in Forth before proceeding.",
      "label.state": "State"
    },
    "ssnValid": {
      "description": "Verifies the contact has a Social Security Number on file in a valid format (exactly 9 digits). This is a prerequisite for the duplicate checks, which search Forth by SSN — when it is missing or invalid those checks are skipped rather than errored.",
      "displayName": "Social Security Number",
      "pass": "Valid Social Security Number on file",
      "fail.missing": "No Social Security Number on file",
      "fail.invalid": "Social Security Number is invalid — must be exactly 9 digits",
      "remediation.missing": "Enter the client's Social Security Number before proceeding.",
      "remediation.invalid": "Correct the client's Social Security Number — it must be exactly 9 digits.",
      "label.ssn": "SSN"
    }
  }
}
